import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router';
import { BrandLockup, BrandSplash } from '../components/Brand';
import { LoadError } from '../components/Page';
import { useSession } from './session';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const { session, ready, me, meLoading, meError, signOut } = useSession();
  const location = useLocation();
  if (!ready || meLoading) return <BrandSplash />;
  if (!session) {
    // come back here after sign-in (e.g. a scanned label link /a/<company>/<asset>)
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  if (meError)
    return (
      <Box sx={{ p: 3 }}>
        <LoadError error={meError} />
      </Box>
    );
  if (me && !me.company && !me.platform_admin) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 4,
          p: 2,
          bgcolor: 'background.default',
        }}
      >
        <BrandLockup size="md" />
        <Card
          variant="outlined"
          sx={{ maxWidth: 420, borderTop: 4, borderTopColor: 'primary.main' }}
        >
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h6" gutterBottom>
              {t('login.no_access_title')}
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>
              {t('login.no_access_body')}
            </Typography>
            <Button variant="outlined" onClick={() => void signOut()}>
              {t('common.sign_out')}
            </Button>
          </CardContent>
        </Card>
      </Box>
    );
  }
  return <>{children}</>;
}
